// internationalization
import type { TFunction } from 'i18next';

// libraries
import { z } from 'zod';

export function createMoveNodeFormSchema(t: TFunction) {
  return z.object({
    parentId: z
      .string()
      .min(1, t('input.required', { ns: 'validation' }))
      .nullable()
      .refine((val) => val !== null && val !== '', {
        message: t('input.required', { ns: 'validation' }),
      }),
  });
}

export type MoveNodeFormValues = z.infer<
  ReturnType<typeof createMoveNodeFormSchema>
>;
